import FacebookIcon from 'assets/images/icons/social/facebook.svg?react';
import InstagramIcon from 'assets/images/icons/social/instagram.svg?react';
import TwitterIcon from 'assets/images/icons/social/twitter.svg?react';
import YouTubeIcon from 'assets/images/icons/social/youtube.svg?react';
import { SocialPlatform } from 'models/DbsSettings';

export const SOCIAL_PLATFORM_PROPS = {
  [SocialPlatform.FACEBOOK]: { key: 'facebook', Icon: FacebookIcon },
  [SocialPlatform.INSTAGRAM]: { key: 'instagram', Icon: InstagramIcon },
  [SocialPlatform.TWITTER]: { key: 'twitter', Icon: TwitterIcon },
  [SocialPlatform.YOUTUBE]: { key: 'youtube', Icon: YouTubeIcon },
} as const;

export const SOCIAL_TABPANEL_ID = 'socialIcons-url-panel';
export const SOCIAL_LABEL_ID = 'socialIcons-label';

export const getSocialTabId = (platform: string) => `social-tab-${platform}`;
